module.exports = __webpack_public_path__ + "assets/videos/green-xmas-video-intro-desktop.mp4?v=15c26161";